import Vue from 'vue'
//import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import vueMoment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'

import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(vueMoment)
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.config.productionTip = false

Vue.prototype.$bus = new Vue();

try {
  if (typeof fetch === "function") {
    fetch(process.env.BASE_URL || "/", { cache: "reload" }).catch(() => {});
  }
} catch (e) {
  /* noop */
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
